/* 🤖 this file was generated by svg-to-ts */
export const iccIconCopyOut: {
  name: 'copy_out';
  data: string;
} = {
  name: 'copy_out',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5 1h-12c-1.1 0-2 .9-2 2v14h2V3h12V1Zm3 4h-11c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2Zm0 16h-11V7h11v14Z" fill="currentColor"/><path d="M14.16 13H10v2h4.16l-1.59 1.59L13.99 18 18 14.01 13.99 10l-1.41 1.41L14.16 13Z" fill="currentColor"/></svg>`
};
